"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getSpectrumConditional = getSpectrumConditional;
function getSpectrumConditional({
  light,
  dark
}, spectrum) {
  return spectrum === 'light' ? light : dark;
}